import React, {useEffect, useState} from 'react'
import { Box } from '@mui/system'
import Sidebar from './sidebar'
import { Button } from '@mui/material';

import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import CustomToolbar from './CustomToolbarPrint';


import { collection, query, getDocs } from "firebase/firestore"; 
import {db} from "../firebase.js";
import deduplicateArchived from "../utils/deduplicateArchived";


export default function Archived() {
    const [rows, setRows] = React.useState([])
    const [deduping, setDeduping] = useState(false);

    let arr = [];
  
    useEffect( () => {
      test()
  
      async function test(){
        arr=[]
        getData()
      }
  
      setRows(arr)
      console.log(arr)
  
  }, []);
  
  async function getData (){
    console.log("me chala")
    let arr = []
    const q = query(collection(db, "archived"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      let obj = doc.data();
      Object.assign(obj, {doc: doc.id});
      console.log(obj)
      arr.push(obj)
     });  
  
     setRows(arr)
  
  }

  async function handleDeduplicate() {
    if (deduping) return;
    setDeduping(true);
    try {
      const result = await deduplicateArchived();
      alert(`Done. Moved ${result.movedCount} duplicate(s) to "deleted" collection.\nRemaining in archive: ${result.totalArchived - result.movedCount}`);
      getData();
    } catch (err) {
      console.error("Deduplicate error:", err);
      alert("Error: " + err.message);
    } finally {
      setDeduping(false);
    }
  }
  
  
  
    const navigate = useNavigate();
    const columns = [
      //{ field: 'id', headerName: 'ID', width: 70 },
      { field: 'firstName', headerName: 'Name', width: 150 },
      { field: 'surName', headerName: 'Surname', width: 150 },
      //{ field: 'lastName', headerName: 'Last Name', width: 150 },
      // {
      //   field: 'age',
      //   headerName: 'Age',
      //   type: 'number',
      // },
      {
          field: 'startDate',
          headerName: 'Start Date',
          // type: 'number',
          width: 170 
          
        },
        { field: 'contact', headerName: 'Contact Number' , width: 150 },

        { field: 'postCode', headerName: 'Post Code' , width: 150 },
        // {
        //   field: "action",
        //   headerName: "",
        //   sortable: false,
        //   renderCell: (params) => {
        //     const onClick = (e) => {
             
              
        //       navigate("/profile");
        //     };
      
        //     return <Button onClick={onClick} style={{color: "#1c3261"}}>View Details</Button>;
        //   }
        // },
        
    
      
    ];
  
    const handleRowClick = (params) => {
      //console.log(params.row);
      navigate("/profileArchived",{
        state: {
          employee: params.row,
        }
      });
    };
    
    return (
  
        
  
        <Box sx={{ display: 'flex' }}>
          <Sidebar />
       
         
          <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{marginTop: "50px", justifyContent: "center", alignItems: "center"}}>
         
         {/* Deduplicate BUTTON TURNED OFF BY TI - 21/5/26 */}
         
          {/* <Box sx={{ mb: 2, display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              disabled={deduping}
              onClick={handleDeduplicate}
              style={{ backgroundColor: "#F21D2F" }}
            >
              {deduping ? "Deduplicating..." : "Remove Duplicates"}
            </Button>
          </Box> */}
          <div style={{ height: 640, width: '100%'}}>
              <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={10}
                  rowsPerPageOptions={[5]}
                  //checkboxSelection
                  onRowDoubleClick={handleRowClick}
                  components={{
                    Toolbar: CustomToolbar,
                  }}
              />
          </div>
          
        </Box>
       
          
      </Box>
  
      
    )
}
